<template>
   <ActDialog img='激活红包' v-model="dialogVisibleC">
        
        <span class="texts">您已激活<i>700</i>元邀请代金红包</span>
      <div class="red-paper">
        <span class="money">¥700</span>

        <img src="@/common/img/编组6.png" alt />
      </div>
      <a href="/MyInfo/myInvite">
        <by-button style="height:30px;width:150px;font-size: 14px;margin-top: 15px;">前往领取</by-button>
      </a>
       </ActDialog>
</template>

<script>
// import ByRedpack from "@/common/components/ByRedpack";

import ActDialog from "@/components/backstageManagement/certification/ActDialog.vue";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dialogVisibleC: {
      get() {
        return this.isShow;
      },
      set(val) {
        console.log(val);
        this.$emit("update:isShow", val); // openCardDialog改变的时候通知父组件
      },
    },
  },
  components: {
    ActDialog,
  },
  // data() {
  //   return {
  //     dialogVisibleC: true,
  //   };
  // },
  methods: {
    // goInvitePage() {
    //   this.$router.push("/MyInfo/myInvite");
    // },
  },
};
</script>

<style lang="scss" scoped>
  .red-paper {
    width: 200px;
    position: relative;
    margin: 0 auto;
    .money {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: 20px;
      color: #f15500;
      font-size: 27px;
      font-weight: 600;
    }
  }
  .texts {
    display: block;
    color: #777777;
    margin: 25px 0 15px 0;
    // margin: 0 0 15px 0;
    // margin-top:25px;
    // &+.texts{
    //   margin-bottom:15px;
    //   margin-top:0
    // }
    i {
      color: #f15500;
    }
  }
.center2 {
  text-align: center;
  h4 {
    font-size: 20px;
    font-weight: 500;
    color: #000000;
  }
  p {
    color: #333333;
    margin: 8px 0 35px 0;
  }
  img {
    margin-left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/public/orderSuccessDialog.vue